// eslint-disable-next-line no-restricted-imports
import Button, { ButtonProps as ButtonPropsBase } from '@mui/material/Button';

import { styled } from '../styled';

import { getStandardMode, getOutlinedMode, getTextMode } from './mode';
import { ButtonProps } from './types';

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== 'colorVariant' &&
    prop !== 'loading' &&
    prop !== 'size' &&
    prop !== 'sizeVariant' &&
    prop !== 'spaceBetween',
})<Omit<ButtonPropsBase, 'color' | 'size'> & ButtonProps>(
  ({
    theme,
    mode,
    loading,
    sizeVariant,
    colorVariant = 'primary',
    fullWidth,
    spaceBetween,
  }) => ({
    boxShadow: 'none',
    flex: 'none',
    textTransform: 'inherit',

    ...(!fullWidth && {
      width: 'fit-content',
    }),

    '&:focus': {
      boxShadow: 'none',
    },
    '& .button-label': {
      lineHeight: '100%',
      textWrap: 'nowrap',
      whiteSpace: 'nowrap',
      fontWeight: 500,
    },

    ...(mode === 'standard' &&
      getStandardMode(theme, colorVariant, sizeVariant)),
    ...(mode === 'outlined' &&
      getOutlinedMode(theme, colorVariant, sizeVariant)),
    ...(mode === 'text' && getTextMode(theme, colorVariant, sizeVariant)),

    ...(loading && {
      '& .button-label': {
        opacity: 0,
      },
    }),

    ...(spaceBetween && {
      justifyContent: 'space-between',
    }),

    '& .button-loading': {
      position: 'absolute',
      display: 'flex',
    },
  })
);
